import React from 'react';

import { HelperText } from './styledComponents';

interface HelperTextProps {
  helperText: string;
  helperTextClassName?: string;
}

const HelperTextStyledComponent = (props: HelperTextProps) => {
  const { helperText, helperTextClassName } = props;
  return (
    <HelperText
      className={helperTextClassName ?? 'helperTextClassName'}
      dangerouslySetInnerHTML={{
        __html: helperText
      }}
    />
  );
};

export { HelperTextStyledComponent };
